var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysSecurity = function SvgSysSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.211 1.08 8.014 1 2 3.514v4.317a8.083 8.083 0 0 0 5.845 7.107L8 15l.159-.062A8.083 8.083 0 0 0 14 7.831v-4.3L8.211 1.08Zm4.871 6.707a7.18 7.18 0 0 1-5.059 6.218 7.184 7.184 0 0 1-5.086-6.192V4.091l5.086-2.123L13.1 4.091l-.018 3.696Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.886 7.45a.365.365 0 0 0-.5.531l1.71 1.594c.066.065.155.1.247.1a.342.342 0 0 0 .255-.109l3.222-3.265a.365.365 0 0 0-.392-.596.356.356 0 0 0-.117.079l-2.984 3.02-1.44-1.354Z"
  })));
};
export default SvgSysSecurity;